<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                        <th>Naam</th>
                        <th>Adres</th>
                        <th>Plaats</th>
                        <th>Telefoonnummer</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                      <td><a href="javascript:void(0)" @click="naarAfdelingen(item.id)" title="Naar afdelingen">{{item.naam}}</a></td>
                        <td>{{item.straatNr}}</td>
                        <td>{{item.postcode}} {{item.plaats}}</td>
                        <td>{{item.tel}}</td>
                        <td nowrap>
                            <router-link :to="'/beheer/bedrijf/edit/' + item.id" title="Bedrijf wijzigen"><i class="fa fa-pencil-square-o"></i></router-link>
                            &nbsp;
                            <a title="Bedrijf verwijderen" href="javascript:void(0)" @click="bevestigItem(item.id, item.naam)" v-show="(user.m >= 7) && (item.deleteok)"><i class="fa fa-trash"></i></a>

                            <span v-show="(! item.deleteok) && (user.m >= 7)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <a v-show="(! item.deleteok) && (user.m >= 7)" title="Bedrijf verwijderen (incl. alle afdelingen en teelten)" href="javascript:void(0)" @click="bevestigItem2(item.id, item.naam)"><i class="fa fa-bell-slash-o"></i></a>

                        </td>
                    </tr>
                    </tbody>
                </table>
                <nav>
                    <ul class="pagination" v-show="user.m >= 7">
                        <li class="page-item"><router-link class="page-link" to="/beheer/bedrijf/new">Bedrijf toevoegen</router-link></li>
                    </ul>
                </nav>
            </div><!--/.row-->
        </div>

        <b-modal title="Verwijderen" size="sm" v-model="warningModal" @ok="deleteItem">
            Bedrijf <b>{{name}}</b> wordt verwijderd. Bent u zeker?
        </b-modal>

        <b-modal title="Verwijderen" size="sm" v-model="warningModal2" @ok="deleteItem2">
            Bedrijf <b>{{name}}</b> (incl. alle afdelingen en teelten) wordt verwijderd. Bent u zeker?
        </b-modal>

    </div>
</template>

<script>
    export default {
        name: 'List',
        props: ['items'],
        data () {
            return {
                id: -1,
                name: '',
                warningModal: false,
                warningModal2: false,
            };
        },
        computed: {
            user () {
                return this.$store.getters.user;
            },
        },
        methods: {
            naarAfdelingen (id) {
                this.$store.dispatch('setBedrijfAfdelingFilter', id);
                this.$router.push('/beheer/afdeling');
            },
            bevestigItem (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal = true;
            },
            deleteItem () {
                this.warningModal = false;
                this.$emit('delete-item', this.id);
            },
            bevestigItem2 (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal2 = true;
            },
            deleteItem2 () {
                this.warningModal2 = false;
                this.$emit('destroy-item', this.id);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/bedrijf/List.vue